import { useCallback } from 'react';
import { fetchHierarchyFromFirestore } from '../services/firestore';

const useNavbarHandler = ({
  setIsLoading,
  setError,
  createNodesFromData,
  createEdgesFromData,
  setNodesWithChildren,
  setNodes,
  setEdges,
  setExpandedNodes,
  setExpandedContent,
  setIsSearchTriggered,
  setShowSearchSuggestions,
  setTopicData,
}) => {
  const handleNavbarClick = useCallback(
    async (topicContent, user) => {
      try {
        setIsLoading(true);
        setError(null);

        setIsSearchTriggered(true); // Move the search bar to the top-left
        setShowSearchSuggestions(false);

        const hierarchyData = await fetchHierarchyFromFirestore(topicContent, user?.uid);

        if (!hierarchyData?.length) {
          setError(`No data found for the topic: "${topicContent}"`);
          return;
        }

        const newNodes = createNodesFromData(hierarchyData);
        const newEdges = createEdgesFromData(hierarchyData);

        // Identify nodes with children
        const nodesWithChildrenSet = new Set(
          hierarchyData
            .filter((item) => hierarchyData.some((child) => child.parent_id === item.id))
            .map((item) => `${item.id}`)
        );

        setNodesWithChildren(nodesWithChildrenSet);
        setNodes(newNodes);
        setEdges(newEdges);

        // Reset expanded states
        setExpandedNodes({});
        setExpandedContent({});

        setTopicData(hierarchyData);

      } catch (err) {
        console.error('Error fetching topic data:', err);
        setError('Failed to load the topic. Please try again.');
      } finally {
        setIsLoading(false);
      }
    },
    [
      setIsLoading,
      setError,
      createNodesFromData,
      createEdgesFromData,
      setNodesWithChildren,
      setNodes,
      setEdges,
      setExpandedNodes,
      setExpandedContent,
      setIsSearchTriggered,
      setShowSearchSuggestions,
      setTopicData
    ]
  );

  return { handleNavbarClick };
};

export default useNavbarHandler;
